module.exports = __webpack_public_path__ + "static/media/user-circle-solid.0161344a.svg";